import Header from "./Components/header";
import OrderDetails from "./Components/orderdetails";
import ShipmentSummary from "./Components/shipmentSummary";
import Trackingandnotes from "./Components/trackingandnotes";
import Fulfilment from "./Components/fulfilment";

export default function PrintableOrderDetails({
  data,
  AdditionalCostTotal,
  setadditionalCosts,
  additionalCosts,
  deletedids,
  setdeletedids,
  setSnack,
  setData,
  setOrders,
  cost,
  setcost,
  value,
  setValue,
  open,
  additonalPrice,
  setadditonalPrice,
  setAdditionalCostTotal,
  selectedStatus,
  setselectedStatus,
  Packinglist,
  orderStatus,
}) {
  return (
    <>
      <div
        className="print-light-surface invoice__modal_box printable__invoice printable__order__details"
      >
        {/* <Row className="mx-auto">
          <Col md={12} className="mx-auto">
            <Row> */}
        <Header order={data} handleClose={null} type="print" />
        <OrderDetails
          data={data}
          AdditionalCostTotal={AdditionalCostTotal}
          type="print"
          Packinglist={Packinglist}
        />
        <ShipmentSummary
          data={data}
          selectedStatus={selectedStatus}
          orderStatus={orderStatus}
          type="print"
        />

        <Trackingandnotes data={data} type="print" />
        {!Packinglist && (
          <Fulfilment
            editable={false}
            data={data}
            AdditionalCostTotal={AdditionalCostTotal}
            setadditionalCosts={setadditionalCosts}
            additionalCosts={additionalCosts}
            deletedids={deletedids}
            setdeletedids={setdeletedids}
            setSnack={setSnack}
            setData={setData}
            setOrders={setOrders}
            cost={cost}
            setcost={setcost}
            value={value}
            setValue={setValue}
            open={open}
            additonalPrice={additonalPrice}
            setadditonalPrice={setadditonalPrice}
            setAdditionalCostTotal={setAdditionalCostTotal}
            selectedStatus={selectedStatus}
            setselectedStatus={setselectedStatus}
            type="print"
            orderStatus={orderStatus}
          />
        )}
        {/* </Row>
          </Col>
        </Row> */}
      </div>
    </>
  );
}
